

<template>
  <div class="container-fluid d-flex flex-column" :class="bgClass">
    <top-bar
      class="pt-1 flex-shrink-0"
      showUsers="true"
      :isPublicVersion="true"
      :hideMenu="$route.meta.hideMenu"
      v-if="isTopBarVisible"
    />
    <div class="row content no-gutters">
      <div class="col d-flex">
        <transition name="fade" mode="out-in">
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import TopBar from '@/components/_layout/TopBar'

export default {
  components: {
    TopBar,
  },
  computed: {
    bgClass() {
      return this.$route.meta.bgClass || 'wave-bg '
    },
    isTopBarVisible() {
      return !this.$route.meta.isTopBarHidden
    },
  },
}
</script>
<style scoped>
.wave-bg {
  background: url('~@/assets/svg/background.svg');
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 50vw;
}
.register-bg {
  background-color: #f8f9f9;
  background-image: url('~@/assets/svg/background-register.svg');
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: bottom;
  background-size: 70vw;
  /* background-position-y: calc(100vh - 600px); */
  /* background-size: 100vh; */
}
</style>
